import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import './HomePage.css';

import ServiceTile from '../ServiceTile';


import highFive from '../../assets/images/hifive.jpeg';
import dogParallax from '../../assets/images/dog-parallax.webp'; 
import newClient from '../../assets/images/new-client.webp'; 

import mavCute from '../../assets/images/indoor-fun.webp';
import homePage1 from '../../assets/images/test/home-page1.webp';
import homePage2 from '../../assets/images/test/home-page2.webp';
// home-page3.webp dropped from the hero rotation 2026-05-09 — cushion-dominant
// composition can't be cropped acceptably for the wide hero frame.
import scheduleToday from '../../assets/images/test/schedule-today.webp'; 

import MeetAndGreetModal from '../../modals/MeetAndGreetModal';



import FooterV2 from '../FooterV2';

import scrollToTop from '../../utils/scrollToTop';

import serviceTileInfo from '../../data/serviceTileInfo';
import PreloadedImages from '../PreloadedImages';
import servicesAndPricing from '../../data/servicesAndPricing';
import ConfirmationModal from '../../modals/ConfirmationModal';



const HomePage = () => {
  // 2026-05-09 hero refresh — each image picks its own object-position so
  // the dog faces stay framed in the desktop crop (which is ~2.1:1 at the
  // hero's max-height: 600px, on nearly-square source photos).
  // home-page3.webp was dropped from rotation entirely; the cushion is too
  // visually dominant for any object-position to save the composition.
  const images = [ // eslint-disable-line react-hooks/exhaustive-deps
    { src: homePage1, objectPosition: 'center 30%' }, // collie + doodle, eyes ~35% y
    { src: homePage2, objectPosition: 'center 18%' }, // two doodles, eyes very high in source
    { src: mavCute,   objectPosition: 'center 28%' }, // 3 dogs indoor, eyes ~28% y
  ];
  const history = useHistory();
  const [bannerImageIndex, setBannerImageIndex] = useState(0);
  const [bannerMessageIndex, setBannerMessageIndex] = useState(0);

  const [meetAndGreetModalOpen, setMeetAndGreetModalOpen] = useState(false);
  const [meetAndGreetConfirmationOpen, setMeetAndGreetConfirmationOpen] = useState(false);
  
  const messages = [ // eslint-disable-line react-hooks/exhaustive-deps
    { text: 'Click to Schedule Your Visit', path: '/meet-and-greet' },
    { text: 'New Clients Always Welcome', path: '/new-clients' },
  ];


  const handleOpenMeetAndGreetModal = () => {
    setMeetAndGreetModalOpen(true);
  };
  
  const handleCloseMeetAndGreetModal = () => {
    setMeetAndGreetModalOpen(false);
  };
  
  const handleMeetAndGreetSuccess = () => {
    setMeetAndGreetModalOpen(false);
    setMeetAndGreetConfirmationOpen(true);
  };
  
  const handleCloseMeetAndGreetConfirmation = () => {
    setMeetAndGreetConfirmationOpen(false);
  };
  




  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
  let timer = 6000;

    if (images.length > 1) {
      const imageInterval = setInterval(() => {
        setBannerImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, timer);

      return () => clearInterval(imageInterval);
    }
  }, [images]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
  let timer = 6000;

    if (messages.length > 1) {
      const messageInterval = setInterval(() => {
        setBannerMessageIndex((bannerMessageIndex + 1) % messages.length);
      }, timer);

      return () => clearInterval(messageInterval);
    }
  }, [messages, bannerMessageIndex]);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('header');
      if (header) {
        document.documentElement.style.setProperty(
          '--header-height',
          `${header.offsetHeight}px`
        );
      }
    };

    updateHeaderHeight(); // Set height on mount
    window.addEventListener('resize', updateHeaderHeight); // Update on resize

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);





  return (
    <>
      <Helmet>
        <title>Dog Boarding &amp; Daycare | Ocean Beach, San Diego | The Dog Lodge</title>
        <meta name="description" content="Kennel-free dog boarding &amp; daycare in Ocean Beach, San Diego. Small groups, home-style care for well-behaved dogs. Serving OB, Point Loma &amp; all of San Diego. Call (619) 304-2323." />
        <link rel="canonical" href="https://thedoglodgesd.com/" />
        {/* LCP preload — hero image. fetchpriority hints to the browser that this
            beats the JS bundle and CSS to the network when the connection allows. */}
        <link rel="preload" as="image" href={homePage1} fetchpriority="high" />
      </Helmet>
      <div className="homepage-wrapper flex">
        <div className="welcome-wrapper flex center">
          <div></div>

          <div className="homepage-image-container">
            {images.map((image, index) => (
              <img
                key={image.src}
                src={image.src}
                alt={index === 0 ? "San Diego County Puppy Day Care - Overnight boarding, daycare, and drop-ins available" : ""}
                className={`homepage-image ${
                  bannerImageIndex === index ? ' active' : ''
                }`}
                style={{ objectPosition: image.objectPosition }}
                // First slide is the LCP candidate — eager + high priority.
                // Subsequent rotation frames can wait, the carousel doesn't advance
                // for 6s so lazy is safe.
                loading={index === 0 ? 'eager' : 'lazy'}
                fetchpriority={index === 0 ? 'high' : 'low'}
                decoding={index === 0 ? 'sync' : 'async'}
              />
            ))}
          </div>

          {/* Hero CTA — render only the active message in the DOM so the visible
              label matches the accessible name (WCAG 2.5.3 / IBM label_name_visible).
              The cycling animation is preserved via fade-in keyframe applied each
              time the active key changes. Inactive messages are no longer in the DOM
              at all, so contrast checkers and label-in-name checks see only the
              active text. */}
          {(() => {
            const active = messages[bannerMessageIndex] || messages[0];
            return (
              <button
                key={active.text}
                type="button"
                className="hero-banner-card hero-banner-card--fade"
                onClick={() => {
                  history.push(active.path);
                  scrollToTop();
                }}
              >
                <span className="hero-banner-msg active">
                  <span>{active.text}</span>
                  <span className="hero-banner-card-arrow" aria-hidden="true">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </span>
              </button>
            );
          })()}
        </div>

        <div className="aboutus-container flex center around">
          <div className="aboutus-section flex center">
            <div className="info-orb-wrapper flex center">
              <div className="info-orb flex center  ">
                <button
                  type="button"
                  onClick={() => {
                    history.push('/about');
                    scrollToTop();
                  }}
                  className="info-orb-image smaller flex center"
                  aria-label="About Us"
                >
                  <PreloadedImages
                    src={highFive}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                history.push('/about');
                scrollToTop();
              }}
              className="info-orb-header block-letters"
            >
              About Us
            </button>
          </div>




          <div className="aboutus-section flex center">
            <div className="info-orb-wrapper flex center">
              <div className="info-orb flex center  ">
                <button
                  type="button"
                  onClick={() => {
                    history.push('/new-clients');
                    scrollToTop();
                  }}
                  className="info-orb-image flex center"
                  aria-label="New Clients"
                >
                  <PreloadedImages
                    src={newClient}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                history.push('/new-clients');
                scrollToTop();
              }}
              className="info-orb-header block-letters"
            >
              New Clients
            </button>
          </div>

          <div className="aboutus-section flex center">
            <div className="info-orb-wrapper flex center">
              <div className="info-orb flex center  ">
                <button
                  type="button"
                  onClick={() => {
                    history.push('/meet-and-greet');
                    scrollToTop();
                  }}
                  className="info-orb-image flex center"
                  aria-label="Book a Meet and Greet"
                >
                  <PreloadedImages
                    src={scheduleToday}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                history.push('/meet-and-greet');
                scrollToTop();
              }}
              className="info-orb-header block-letters flex center-letters"
            >
              Book a Meet and Greet
            </button>
          </div>
        </div>



        <div className="parallax-container flex">
          <div className="welcome-image-container">
            <img
              className="welcome-image "
              src={dogParallax}
              alt="an Diego Dog Day Care - Dog playing in backyard"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="parallax-content flex center">
            <h1 className="bio-content header flex">
              Welcome to The Dog Lodge
            </h1>

            <div className="bio-content">
              The Dog Lodge Daycare & Boarding is a cozy, homestyle retreat designed for a select group of well-behaved, mild-mannered pups. We pride ourselves on creating an exclusive, safe, and loving environment where your dog can thrive.
            </div>

            <div className="bio-content">
              We believe in quality over quantity, which is why we keep our services limited to a small group of dogs at any given time. Call us at{' '}
              <a className="white-text" href={`tel:${servicesAndPricing.phone1}`}>
                {servicesAndPricing.phone1}
              </a>{' '}
              to schedule a meet and greet!
            </div>
          </div>
        </div>

        <div className="services-wrapper flex">
          <div className="services-header block-letters flex center">
            {`Pet Boarding & Daycare in San Diego, CA`}
          </div>

          <div className="services-container flex center">
            {Object.entries(serviceTileInfo).map(([key, service], index) => (
              <div key={index} className={`servicetile-wrapper`}>
                <ServiceTile service={service} />
              </div>
            ))}
          </div>
        </div>

  

        <div className="parallax-container flex">
          <div className="welcome-image-container">
            <img
              className="welcome-image"
              src={scheduleToday}
              alt="an Diego Dog Day Care - Dog playing in backyard"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="parallax-content flex center">
            <div className="bio-content header flex">
              {`Welcoming New Clients`}
            </div>

            <div className="bio-content">
             To ensure every pup feels comfortable and fits in with the group, we begin with a simple Meet and Greet. This quick visit lets us get to know your dog, learn about their personality, and see how they’ll thrive in our relaxed, homestyle environment.
            </div>

            <button onClick={handleOpenMeetAndGreetModal} className="homepage-evaluationdaypage-button theme1-button">
              Schedule a Meet &amp; Greet
            </button>

          </div>

        </div>

  

        <FooterV2 />


        {meetAndGreetModalOpen && (
          <MeetAndGreetModal
            isOpen={meetAndGreetModalOpen}
            onClose={handleCloseMeetAndGreetModal}
            onSuccess={handleMeetAndGreetSuccess}
          />
        )}

        {meetAndGreetConfirmationOpen && (
          <ConfirmationModal
            isOpen={meetAndGreetConfirmationOpen}
            onClose={handleCloseMeetAndGreetConfirmation}
            type={'meet-and-greet'}
          />
        )}
      </div>
    </>
  );
};
export default HomePage;
